//#region src/transports/batchExecutor.ts
const DEFAULT_SEND_TIMEOUT_MS = 250;
const DEFAULT_BATCH_ITEM_LIMIT = 50;
var BatchExecutor = class {
	constructor(sendFn, options) {
		var _options$itemLimit, _options$sendTimeout;
		this.signalBuffer = [];
		this.itemLimit = (_options$itemLimit = options === null || options === void 0 ? void 0 : options.itemLimit) !== null && _options$itemLimit !== void 0 ? _options$itemLimit : DEFAULT_BATCH_ITEM_LIMIT;
		this.sendTimeout = (_options$sendTimeout = options === null || options === void 0 ? void 0 : options.sendTimeout) !== null && _options$sendTimeout !== void 0 ? _options$sendTimeout : DEFAULT_SEND_TIMEOUT_MS;
		this.paused = (options === null || options === void 0 ? void 0 : options.paused) || false;
		this.sendFn = sendFn;
		if (!this.paused) this.start();
		if (typeof document !== "undefined") document.addEventListener("visibilitychange", () => {
			if (document.visibilityState === "hidden") this.flush();
		});
	}
	addItem(item) {
		if (this.paused) return;
		this.signalBuffer.push(item);
		if (this.signalBuffer.length >= this.itemLimit) this.flush();
	}
	start() {
		this.paused = false;
		if (this.sendTimeout > 0) this.flushInterval = setInterval(() => this.flush(), this.sendTimeout);
	}
	pause() {
		this.paused = true;
		clearInterval(this.flushInterval);
	}
	groupItems(items) {
		const itemMap = /* @__PURE__ */ new Map();
		items.forEach((item) => {
			const metaKey = JSON.stringify(item.meta);
			let currentItems = itemMap.get(metaKey);
			if (currentItems === void 0) currentItems = [item];
			else currentItems = [...currentItems, item];
			itemMap.set(metaKey, currentItems);
		});
		return Array.from(itemMap.values());
	}
	flush() {
		if (this.paused || this.signalBuffer.length === 0) return;
		const snapshot = this.signalBuffer;
		this.signalBuffer = [];
		try {
			this.groupItems(snapshot).forEach(this.sendFn);
		} catch (error) {
			this.signalBuffer = [...snapshot, ...this.signalBuffer];
			this.trimBufferToLimit();
			throw error;
		}
	}
	trimBufferToLimit() {
		if (this.signalBuffer.length > this.itemLimit) this.signalBuffer = this.signalBuffer.slice(0, this.itemLimit);
	}
};
//#endregion
export { BatchExecutor };

//# sourceMappingURL=batchExecutor.js.map